<template>
  <main class="error">
    <img class="error-img" alt="404" src="../../assets/imgs/404.png" />
    <div class="error-title">ไม่พบข้อมูลที่ค้นหา</div>
    <div class="error-desc">กรุณาลองใหม่อีกครั้ง</div>
    <div class="button" @click="close">ตกลง</div>
  </main>
</template>

<script>
export default {
  props: {
    userID: String,
    env: Object,
    finnakies: String
  },
  data() {
    return {};
  },
  metaInfo: {
    title: "Not Found"
  },
  async created() {},
  async mounted() {},
  methods: {
    close() {
      this.$liff.closeWindow();
    }
  },
  updated() {}
};
</script>

<style lang="scss" scoped>
.error {
  text-align: center;
  vertical-align: middle;

  .error-img {
    margin-top: 12vh;
    margin-bottom: 3vh;
  }

  .error-title {
    padding: 2px 62px;
    color: $color-normal-text;
    font-size: 22px;
  }

  .error-desc {
    padding: 8px 62px;
    font-size: 18px;
    color: $color-secondary-text;
  }

  .error-code {
    padding: 2px 62px;
    font-size: 14px;
    color: $color-light-grey;
  }

  .button {
    font-size: 16px;
    border-radius: 4px;
    max-width: 115px;
    margin: 10px auto;
    padding: 4px 12px;
    background-color: $color-primary-finno;
    flex-direction: row;
    vertical-align: middle;
    cursor: pointer;
  }
}
</style>

